
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { initWebVitals } from './utils/web-vitals';
import { initAnalytics, webVitalsHandler } from './utils/analytics';
import env from './config/env';

// Update the health check timestamp on load in production
if (env.isProduction) {
  fetch('/health')
    .then(response => response.json())
    .then(data => {
      const updatedHealthCheck = {
        ...data,
        timestamp: new Date().toISOString(),
        version: env.appVersion
      };
      
      // In a real app, you might want to update this on the server
      console.log('Health check:', updatedHealthCheck);
    })
    .catch(error => {
      console.error('Error updating health check:', error);
    });
}

// Initialize analytics with appropriate configuration
initAnalytics({
  enabled: env.analyticsEnabled,
  provider: (env.analyticsProvider || 'console') as any,
  trackErrors: true,
  anonymizeIp: true
});

// Initialize web vitals monitoring with analytics handler
if (!import.meta.env.SSR) {
  initWebVitals(webVitalsHandler);
}

// Debug logging for app initialization
console.log('🚀 App starting - main.tsx initialized');

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register service worker for PWA using VitePWA helper (production only)
if (env.isProduction) {
  // The virtual module is tree-shaken in dev and only injected in prod builds
  import('virtual:pwa-register').then(({ registerSW }) => {
    try {
      registerSW({ immediate: true, onRegisteredSW: () => {/* noop */} });
      console.log('PWA service worker registration initialized');
    } catch (error) {
      console.error('PWA service worker registration failed:', error);
    }
  }).catch((e) => {
    console.error('Failed to load PWA register module:', e);
  });
}
